import {
  styled,
  TextField as TextFieldOriginal,
  TextFieldProps,
  Tooltip,
} from '@mui/material';

import React, { CSSProperties, useRef } from 'react';
import { deprecatedClassnames } from '../helpers/cssHelpers';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ErrorMessage } from './Label';
import { bgColorsVars } from '@design-system/vars.css';
import { input } from '@design-system/components/input/input.css';
export * from '@mui/material';
const StyledTextField = styled(TextFieldOriginal)(
  (p: { ['data-style']?: CSSProperties }) => ({
    borderRadius: 8,
    '& .MuiFormLabel-asterisk': {
      color: bgColorsVars['ERROR-100'],
    },
    '& input': {
      ...p['data-style'],
    },
  }),
);
type Props = TextFieldProps & {
  errorMsg?: string;
  helpertext?: string;
  ['data-style']?: CSSProperties;
};
export const TextField = React.forwardRef<HTMLInputElement, Props>(
  ({ errorMsg, ...props }: Props, ref) => {
    const myRef = useRef<HTMLInputElement | undefined>(undefined);

    const inputElement =
      myRef.current?.querySelector('input') ||
      myRef.current?.querySelector('textarea');
    const value = inputElement?.value || '';

    const tapRef = React.useCallback(
      (node: HTMLInputElement) => {
        myRef.current = node;
        if (typeof ref === 'function') ref(node);
        else if (ref) ref.current = node;
      },
      [ref],
    );
    const errContent = (props.error ? props.helpertext : '') || errorMsg;
    const error =
      props.error === undefined
        ? errorMsg !== '' && errorMsg !== undefined
        : props.error;

    return (
      <div
        className="relative w-full"
        style={{ gap: '8px', display: 'inline-grid' }}
      >
        <div className="relative w-full">
          <StyledTextField
            {...props}
            error={error}
            ref={tapRef}
            className={'w-full bg-white ' + input + ' ' + props.className}
            sx={{
              fontFamily: 'Visuelt',
              '& .MuiInputBase-input::placeholder': {
                color: '#646464',
                fontWeight: 500,
              },
            }}
          />
          {props.inputProps?.maxLength > 0 && (
            <span className="absolute bottom-[-20px] right-[10px] text-gray-200 text-xs z-1">
              {value.length}/{props.inputProps?.maxLength}
            </span>
          )}
        </div>
        <ErrorMessage content={errContent} />
      </div>
    );
  },
);

export function ClickableIcon({
  icon,
  warn,
  className,
  title,
  ...props
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  icon: any;
  warn?: boolean;
  className?: string;
  title: string;
  onClick?: () => void;
}) {
  const hoverClass = warn ? 'hover:text-red-500' : 'hover:text-primary';
  return (
    <Tooltip title={title}>
      <FontAwesomeIcon
        {...props}
        icon={icon}
        className={deprecatedClassnames(
          'cursor-pointer text-xl md:text-2xl hover:scale-125',
          hoverClass,
          className || '',
        )}
      />
    </Tooltip>
  );
}
